import { connect, ConnectedProps } from 'react-redux'
import { ReduxState } from 'store/createRootReducer'
import * as actions from '../../actions'
import * as selectors from '../../selectors'

type OwnProps = {
  countryId?: number
  regionId?: number
}

const mapStateToProps = (state: ReduxState, ownProps: OwnProps) => {
  return {
    isLoading: selectors.isLoadingSelector(state, 'isUpdateRegion'),
    region: selectors.regionSelector(state, ownProps.countryId, ownProps.regionId)
  }
}

const mapDispatchToProps = {
  fetchRegion: actions.fetchRegion,
  updateRegion: actions.updateRegion
}

export const connector = connect(mapStateToProps, mapDispatchToProps)
export type PropsFromRedux = ConnectedProps<typeof connector> & OwnProps
